import { render, staticRenderFns } from "./OctMedia.vue?vue&type=template&id=fe882908&scoped=true&"
import script from "./OctMedia.vue?vue&type=script&lang=js&"
export * from "./OctMedia.vue?vue&type=script&lang=js&"
import style0 from "./OctMedia.vue?vue&type=style&index=0&id=fe882908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe882908",
  null
  
)

export default component.exports